export const terminationStatusToString = status => {
  switch(status) {
    case 'JOB_ABANDONMENT':
      return 'Job abandonment'

    case 'QUIT':
      return 'Quit'

    case 'PERSONAL_REASON':
      return 'Personal reason'

    case 'NEW_EMPLOYMENT':
      return 'New employment'

    case 'DISSATISFACTION':
      return 'Dissatisfaction'

    case 'MANAGEMENT':
      return 'Management'

    case 'WORK_PERFORMANCE':
      return 'Work performance'

    case 'ATTENDANCE':
      return 'Attendance'

    case 'COMPANY_POLICY_VIOLATION':
      return 'Company policy violation'

    case 'RECORD_FALSIFICATION':
      return 'Record falsification'

    case 'INSOBURDINATION':
      return 'Insubordination'

    default:
      return 'Other'
  }
}



// WEBPACK FOOTER //
// ./src/utils/termination.ts